export default props => ({
    pageBgColor: 'unset',
    contentBgColor: props.theme.uiBackground,
    // Content spacing is applied to the Main content, and controls space between header, main, and footer content
    contentPadding: '0',

    ...props.theme?.templates?.chrome
  });
